<template>
	<div class="info-field-wrap" v-if="isActive && !isIgnore">
		<p class="field-name">{{ tt(fieldName) }}</p>
		<div v-if="isRequire && isData == null" class="field-data-wrap-red">{{ tt('미입력') }}</div>
		<div v-else class="field-data-wrap" :class="{ unfold: isFold }">
			<div class="field-text" v-html="fieldValue" :class="{ unfold: isFold }" ref="field-text"></div>
			<img
				v-if="isShowTriangle"
				class="fold-triangle"
				:src="require(`@/views/purchase/cargo/svg/triangle-${isFold ? 'up' : 'down'}.svg`)"
				@click="isFold = !isFold"
			/>
		</div>
	</div>
</template>
<script>
export default {
	name: 'CustomInfoField',
	components: {},
	props: {
		item: {
			type: Object,
			default: null,
		},
		isActive: {
			type: Boolean,
			default: true,
		},
		isRequire: {
			type: Boolean,
			default: false,
		},
		fieldInfo: {
			type: Object,
			default: null,
		},
		fieldName: {
			type: String,
			default: '',
		},
		fieldText: {
			type: [String, Number],
			default: '',
		},
		isData: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			isFold: false,
		}
	},
	computed: {
		fieldValue() {
			return this.fieldText.replace(/\\r\\n|\\n|\\r/gm, '<br />')
		},
		isIgnore() {
			return ['tag', 'image', 'buyDatetime', 'price', 'createDatetime'].includes(this.fieldInfo.key)
		},
		isShowTriangle() {
			return this.getCountLines(this.fieldText) > 1 || this.getTextWidth(this.fieldText) >= 280
		},
	},
	watch: {},
	created() {},
	mounted() {},
	methods: {
		getTextWidth(text) {
			let font = '16px Pretendard'
			let canvas = document.createElement('canvas')
			let context = canvas.getContext('2d')
			context.font = font
			let width = context.measureText(text).width
			let formattedWidth = Math.ceil(width)
			return formattedWidth
		},
		getCountLines(text) {
			return text.split('\\r\\n').length - 1
		},
	},
}
</script>

<style lang="scss" scoped>
.info-field-wrap {
	padding-right: 10px;
	.field-name {
		text-align: left;
		font-size: 12px;
		font-weight: 400;
		color: $SECONDARY_2;
		margin-bottom: 6px !important;
	}
	.field-data-wrap {
		display: block;
		width: 280px;
		height: 20px;
		position: relative;
		&.unfold {
			height: auto;
		}
		.field-text {
			font-size: 14px;
			font-weight: 400;
			text-align: left;
			overflow: hidden;
			word-break: break-all;
			text-overflow: ellipsis;
			white-space: nowrap;
			max-height: 40px;
			&.unfold {
				text-overflow: unset;
				white-space: unset;
				max-height: none;
			}
		}
		.fold-triangle {
			position: absolute;
			top: 0px;
			right: -13px;
			cursor: pointer;
		}
	}
	.field-data-wrap-red {
		width: 280px;
		height: 20px;
		font-size: 14px;
		font-weight: 400;
		text-align: left;
		color: $RED;
	}
}
</style>
